import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
/**
 * Daylight's type scale, spelled out for tailwind-merge.
 *
 * Without this, `cn('text-body', 'text-primary')` returns just `text-primary`.
 * tailwind-merge cannot tell a custom font-size key from a colour: both are
 * `text-<word>`, so it treats them as one group and keeps the last. Every
 * component that lets a caller pass a text colour was quietly losing its font
 * size. Naming the sizes puts them in their own group, and the colours keep
 * falling through to `text-color`.
 */
const FONT_SIZES = [
    'display',
    'h1',
    'h2',
    'h3',
    'h4',
    'body',
    'body-sm',
    'label',
    'button',
    'caption',
    'numeric',
    'question',
];
/**
 * The named spacing tokens, spelled out for the size groups.
 *
 * Same failure as the type scale above, one level over. tailwind-merge does
 * not recognise `control-md` as a length, so `h-control-md` never joined the
 * height group at all and `cn('h-control-md', 'h-control-lg')` returned both.
 * Nothing errored: the browser applied whichever Tailwind happened to emit
 * last, so a caller's height override worked or did not depending on the
 * alphabetical order of two custom properties.
 *
 * Registering the tokens for `h`, `w` and `size` puts them in the real groups,
 * and the `size`-versus-`h`/`w` conflicts that tailwind-merge already knows
 * about start applying to them too.
 */
const SPACING_TOKENS = [
    'control-sm',
    'control-md',
    'control-lg',
    'touch-target-min',
    'header',
    'icon-sm',
    'icon-md',
    'icon-lg',
    'sidebar',
    'sidebar-rail',
];
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: [...FONT_SIZES] }],
            h: [{ h: [...SPACING_TOKENS] }],
            w: [{ w: [...SPACING_TOKENS] }],
            size: [{ size: [...SPACING_TOKENS] }],
        },
    },
});
/**
 * Merge conditional class names, then resolve conflicting Tailwind
 * utilities in favour of the one that appears last (so a consumer's
 * `className` prop can override an atom's own defaults).
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map